import { GET_ALL_OFFLINE_CLASSROOMS } from '../actions/types';

const initialState = [];

const OfflineClassRoomReducer = (state = initialState, action) => {
  const { type = {}, payload } = action || {};
  switch (type) {
    case GET_ALL_OFFLINE_CLASSROOMS:
      return payload;
    default:
      return state;
  }
};

export { OfflineClassRoomReducer };
